import { render, staticRenderFns } from "./FreelanceTab.htm?vue&type=template&id=16a836e6&scoped=true&"
import script from "./FreelanceTab.ts?vue&type=script&lang=js&"
export * from "./FreelanceTab.ts?vue&type=script&lang=js&"
import style0 from "./FreelanceTab.scss?vue&type=style&index=0&id=16a836e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a836e6",
  null
  
)

export default component.exports